export const LOGIN_FORM_UPDATE = 'LOGIN_FORM_UPDATE';

export const updateLoginForm = (e) => ({
  type: LOGIN_FORM_UPDATE,
  payload: {
    [e.target.name]: e.target.value
  }
});



// WEBPACK FOOTER //
// ./src/actions/loginForm.js